import React, { useEffect, useRef, useState } from "react";
import OrderAttachments from "./OrderAttachments";
import "./order-attachments.scss";

const ImageZoom = (props) => {
  const [finalImages,setFinalImages] = useState([]);
  useEffect(()=>{
    let dummyArr = [];
    if(typeof props.images[0] !== "object"){
      props.images.forEach((image,index)=>{
      let obj = {};
      obj['url'] = image;
      obj['fileId'] = index + 1;
      obj['text'] = `image${index+1}`;
      dummyArr.push(obj);
    })
  }else{
    dummyArr = [...props.images];
  }
    setFinalImages(dummyArr);
  },[props.images])

  const deleteImage = (e, index, updateServer = true) => {
		e && e.stopPropagation();
    let dummyList = [...finalImages];
    dummyList.splice(index,1);
		props.updateList(dummyList);
	};

  return (
    <>
      {
        props.title && 
        <div className="marginLR15 branded-prop-name">
          {props.title}
        </div>
      }
      <div className={`marginB20 ${props?.imageHolderClass}`}>
        <OrderAttachments
          maxFiles={3}
          list={finalImages}
          // popClickOptions={onOptionClick}
          isMobile={true}
          isError={false}
          editable={props.editable ? true : false}
          onCross={deleteImage}
          isAuditor={props.isAuditor}
        />
      </div>
    </>
  );
};

export default ImageZoom;
